import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { useState, useEffect } from 'react';

export type ErrorStatus =
  | { tag: 'Submited'; errors: string[] }
  | { tag: 'Not submitted' };

/**
 * Controlled component (all actions are performed in this component), 
 * works with strings and 
 * allows you to enter any text.
 */
export interface DropdownStringSelectorProps {
  defaultValue?: string | null;
  onSelect: (value: string | null) => void;
  values: string[];
  label: string;
  icon?: string | null;
  closeIcon?: string | null;
  className?: string;
  buttonClassName?: string;
  title?: string;
  subtitle?: string | null;
  disabled: boolean;
  required?: boolean;
  open?: boolean;
  name: string;
  setOpen?: (open: boolean) => void;
  errors?: ErrorStatus;
}

const DropdownStringSelector: React.FC<DropdownStringSelectorProps> = ({
  defaultValue = null,
  label,
  values,
  onSelect,
  className,
  disabled,
  required,
  name,
  errors,
  open,
  setOpen,
}) => {
  const error = !!(
    errors &&
    errors.tag === 'Submited' &&
    errors.errors.length !== 0
  );
  const helperText =
    errors && errors.tag === 'Submited' ? errors.errors.join(', ') : '';

  const [inputValue, setInputValue] = useState(defaultValue ?? '');

  useEffect(() => {
    setInputValue(defaultValue ?? '');
  }, [defaultValue]);

  return (
    <Autocomplete
      freeSolo
      disablePortal
      noOptionsText={`Pas d'options de sélection`}
      options={values}
      getOptionLabel={(option) => (typeof option === 'string' ? option : '')}
      onChange={(_, value) => {
        // value = string | null
        onSelect(typeof value === 'string' ? value : null);
      }}
      inputValue={inputValue}
      onInputChange={(_, value, reason) => {
        setInputValue(value);
        if (reason !== 'reset') {
          onSelect(value === '' ? null : value);
        }
      }}
      value={defaultValue ?? null}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          required={required}
          name={name}
          error={error}
          helperText={helperText}
        />
      )}
      className={className}
      disabled={disabled}
      open={open}
      onOpen={setOpen ? () => setOpen(true) : undefined}
      onClose={setOpen ? () => setOpen(false) : undefined}
    />
  );
};

export default DropdownStringSelector;